import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "AccuwareLogo"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.07875 3.0693L4.62178 13.964L14.7422 8.12088L5.07875 3.0693Z",
  fill: "#A6D1FF"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.45",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.18308 6.75781L1.01058 7.75276L4.61976 14.0041L10.9245 13.219L7.18308 6.75781Z",
  fill: "#59A8FE"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.55",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.19287 6.75679L11.1408 1.90866L14.7412 8.11993L10.9233 13.2181L7.19287 6.75679Z",
  fill: "#268EFE"
}, null, -1);
const _hoisted_5 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.346587",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.20766 6.74683L11.16 1.90631L5.10561 3.10592L1.03955 7.7494L7.20766 6.74683Z",
  fill: "#8BC2FE"
}, null, -1);
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_6);
}
var accuwareLogo = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { accuwareLogo as default };
